(function () {
  'use strict';

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function matchTerm(title, term) {
    if (!title || !term) return false;
    var re = new RegExp(escapeRegExp(term) + '(?![\\w])', 'i');
    return re.test(title);
  }

  function formatMan(v) {
    return (Math.round(v / 1000) / 10).toFixed(1) + '万';
  }

  function minVariantPrice(p) {
    if (!p.variants || !p.variants.length) return null;
    var min = Infinity;
    p.variants.forEach(function (v) {
      var price = parseFloat(v.price);
      if (!isNaN(price) && price > 0) min = Math.min(min, price);
    });
    return min === Infinity ? null : min;
  }

  function fetchPage(page) {
    return fetch('/collections/gaming-pc/products.json?limit=250&page=' + page)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchAll() {
    var results = [];
    function next(page) {
      return fetchPage(page).then(function (data) {
        if (!data || !data.products || !data.products.length) return results;
        Array.prototype.push.apply(results, data.products);
        if (data.products.length < 250 || page >= 5) return results;
        return next(page + 1);
      });
    }
    return next(1);
  }

  function populate(table, products) {
    var cells = table.querySelectorAll('.pct-cell[data-cpu][data-gpu]');
    cells.forEach(function (cell) {
      var cpu = cell.dataset.cpu;
      var gpu = cell.dataset.gpu;
      var count = 0;
      var minP = Infinity;
      products.forEach(function (p) {
        var title = p.title || '';
        if (matchTerm(title, cpu) && matchTerm(title, gpu)) {
          count += 1;
          var mp = minVariantPrice(p);
          if (mp != null) minP = Math.min(minP, mp);
        }
      });
      var countEl = cell.querySelector('[data-role="count"]');
      var priceEl = cell.querySelector('[data-role="price"]');
      if (count === 0) {
        if (countEl) countEl.textContent = '—';
        return;
      }
      if (countEl) countEl.textContent = count + '商品';
      if (priceEl && minP !== Infinity) {
        priceEl.textContent = formatMan(minP) + '〜';
      }
    });
  }

  function init() {
    var table = document.querySelector('.pct-table');
    if (!table) return;
    fetchAll().then(function (products) {
      if (products && products.length) populate(table, products);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
